import React, { Component } from 'react'
import Masonry from 'react-masonry-component'
import PropTypes from 'prop-types'
import MediaQuery from 'react-responsive'

// Components
import Categories from '../categories/Categories'
import WorkElement from './workelement/WorkElement'

// JS
import { DESKTOPTABLETDEVICEWIDTH } from '../../../../utils/constants'

// CSS
import './WorkOverview.css'

class WorkOverview extends Component {

  static propTypes = {
    projects: PropTypes.array.isRequired,
    categories: PropTypes.array.isRequired,
    selectedCategory: PropTypes.string,
    onSelectCategory: PropTypes.func.isRequired
  }

  render() {
    return (
      <div className='work-overview-container'>

        <MediaQuery minDeviceWidth={DESKTOPTABLETDEVICEWIDTH}>
          {(matches) => {
            if (matches) {
              return (
                <div>
                  <Categories categories={this.props.categories} selectedCategory={this.props.selectedCategory} onSelectCategory={this.props.onSelectCategory} />
                  <Masonry
                    className={'work-overview'}
                    elementType={'ul'}
                    options={{
                      columnWidth: 300
                    }}
                  >
                    {this.props.projects.map(project => {
                      return <WorkElement key={project.url} project={project} />
                    })}
                  </Masonry>
                </div>
              )
            }  else {
              return(
                <ul className={'work-overview mobile'}>
                  {this.props.projects.map(project => {
                      return <WorkElement key={project.url} project={project} />
                    })}
                </ul>
              )
            }}}
        </MediaQuery>
       

        
      </div >
        )
  }
}

export default WorkOverview;


// WEBPACK FOOTER //
// ./src/components/main/work/workoverview/WorkOverview.js